import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { UiIcon, UiButton, UiAvatar } from 'ui-components';
import { cutString, getAvatar, mapPlatform } from 'utils';
import { StyledQuote } from './Quote.styles';

const quotePlatformConfig = {
  twitter: {
    route: (quoteId) => `/contents/twitter/${quoteId}/twitterInfo`,
    icon: 'ri-twitter-line',
    viewOriginalKey: 'content:viewOriginalTweet',
  },
  virasty: {
    route: (quoteId) => `/contents/virasty/${quoteId}/virastyInfo`,
    icon: 'virasty-line-active',
    viewOriginalKey: 'content:viewOriginalPost',
  },
};

const Quote = ({ className, quote, length, platform = 'twitter' }) => {
  const { route, icon, viewOriginalKey } = quotePlatformConfig[platform];
  const { avatar, title, username, description, url, id: quoteId } = quote;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();

  const handleClick = () => {
    const quoteRoute = route(quoteId);
    if (id) {
      window.location.href = quoteRoute;
    } else {
      navigate(quoteRoute);
    }
  };

  return (
    <StyledQuote className={className}>
      <div className='flex header'>
        <UiAvatar
          className='avatar-image'
          src={avatar && getAvatar(avatar, platform)}
          variant='rounded'
          sx={mapPlatform[platform]?.avatarSize}
        >
          {title || username}
        </UiAvatar>
        <spav className='title'>{title}</spav>
        {username && (
          <span className='username flex'>
            <UiIcon
              {...(platform === 'virasty' ? { src: icon } : { icon })}
              color='#5AD1F6'
              className='ml-5'
            />
            <bdi>@{username}</bdi>
          </span>
        )}
      </div>
      <div className='user-select'>
        {length ? cutString(description, length) : description}
      </div>
      {url && (
        <div className='text-left mt-24'>
          <UiButton
            variant='text'
            color='primary'
            textColor='#199da3'
            onClick={handleClick}
          >
            {t(viewOriginalKey)}
          </UiButton>
        </div>
      )}
    </StyledQuote>
  );
};

Quote.propTypes = {
  className: PropTypes.string,
  quote: PropTypes.object,
  length: PropTypes.number,
  platform: PropTypes.oneOf(['twitter', 'virasty']),
};

export default memo(Quote);
